import { render, staticRenderFns } from "./Downline.vue?vue&type=template&id=1d97d61e"
import script from "./Downline.vue?vue&type=script&lang=js"
export * from "./Downline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports